const dummyResponseDataForPetroHubUser = { // UserDetails Response{
  User: {
    UserID: 1819,
    FirstName: 'Shyam6',
    LastName: 'vir',
    Email: 'svir2506_6@yopmail.com',
    Active: true,
    Description: '',
    Language: '',
    LicenseNo: null,
    NameOnLicense: null,
    Flags: 2,
    DefaultRoleID: 379,
    CreatedOn: '2026-03-06T07:14:03Z',
    LastUpdatedOn: null,
    CreatedBy: '1200',
    LastUpdatedBy: null,
    Timezone: 'Africa/Accra',
    DateFormat: 'dd/MM/yyyy',
    DateTimeFormat: 'dd/MM/yyyy',
    UserType: 'Client',
    Salutation: '',
    Company: 'null',
    DefaultRoleName: null,
    ApplicationID: null,
    Signature: null,
    ESignature: null,
    StartDate: null,
    EndDate: null,
    CustomFields: null
  },
  UserObjects: [
    {
      UserObjectID: 40249,
      UserID: 1819,
      ObjectType: 'AssignedLocations',
      ObjectData: '[]',
      ApplicationID: 2
    },
    {
      UserObjectID: 40250,
      UserID: 1819,
      ObjectType: 'AssignedDivisions',
      ObjectData: '[9]',
      ApplicationID: 2
    },
    {
      UserObjectID: 40251,
      UserID: 1819,
      ObjectType: 'AssignedSourceSystems',
      ObjectData: '[11]',
      ApplicationID: 2
    },
    {
      UserObjectID: 40252,
      UserID: 1819,
      ObjectType: 'AssignedClients',
      ObjectData: '[]',
      ApplicationID: 2
    },
    {
      UserObjectID: 40253,
      UserID: 1819,
      ObjectType: 'AssignedProjects',
      ObjectData: '[]',
      ApplicationID: 2
    },
    {
      UserObjectID: 40254,
      UserID: 1819,
      ObjectType: 'AssignedSuppliers',
      ObjectData: '[]',
      ApplicationID: 2
    },
    {
      UserObjectID: 40255,
      UserID: 1819,
      ObjectType: 'AssociateContracts',
      ObjectData: '[]',
      ApplicationID: 2
    },
    {
      UserObjectID: 40256,
      UserID: 1819,
      ObjectType: 'FleetAssociates',
      ObjectData: '[]',
      ApplicationID: 2
    }
  ],
  UserRoles: [
    {
      UserToRoleID: 15884,
      RoleID: 379,
      Group1: '{"ID": "588697", "Text": "Almi Marine Management"}',
      Group2: '[{"ID": "27", "Text": "Home"}]',
      Group3: '[{"ID": "185661", "Text": "scenario_2"}]',
      Group4: null,
      Group5: null,
      OverrideRoleSetting: '[{"ID": "179", "Text": "Order"}]',
      RoleName: 'TestNewMax',
      Flags: null,
      RoleLevel: null
    }
  ],
  RoleClaims: [],
  Contacts: [
    {
      ContactID: 2011,
      FirstName: null,
      LastName: null,
      FullName: null,
      CompanyName: null,
      Phone: '98888888888',
      Email: null,
      Fax: null,
      BelongsTo: 'User',
      RecordID: '1819',
      Active: true,
      IsDefault: null,
      Flags: null,
      CreatedBy: '1819',
      CreatedOn: '2026-03-06T07:15:15',
      LastUpdatedBy: null,
      LastUpdatedOn: null
    }
  ],
  Addresses: [
    {
      AddressID: 60,
      AddressLine1: 'sdf',
      AddressLine2: 'sdaf',
      AddressLine3: 'df',
      City: 'sdaf',
      State: 'dfs',
      PostCode: '824201',
      Country: '',
      CountryName: '',
      AddressName: null,
      BelongsTo: 'User',
      RecordID: '1819',
      Active: true,
      IsDefault: true,
      Flags: null
    }
  ],
  UserToRoles: [
    {
      UserToRoleID: 15907,
      UserID: 1819,
      RoleID: 379,
      Active: true,
      IsDefault: null,
      Flags: null,
      CreatedOn: '2026-03-06T10:53:41',
      LastUpdatedOn: null,
      CreatedBy: '1200',
      LastUpdatedBy: null,
      ApplicationID: 2,
      Group1: '{"ID": "588697", "Text": "Almi Marine Management"}',
      Group2: '[{"ID": "27", "Text": "Home"}, {"ID": "27", "Text": "Home"}]',
      Group3: '[{"ID": "185661", "Text": "scenario_2"}, {"ID": "185660", "Text": "scenario_1"}]',
      Group4: null,
      Group5: null,
      OverrideRoleSetting: '[{"ID": "179", "Text": "Order"}, {"ID": "178", "Text": "Cylinder"}]',
      RoleName: 'TestNewMax',
      Level: null
    }
  ],
  Permissions: [
    {
      Code: 'cylinder',
      Options: [
        'S',
        'I',
        'M',
        'E',
        'D'
      ]
    },
    {
      Code: 'order',
      Options: [
        'S',
        'I',
        'M',
        'E',
        'D'
      ]
    },
    {
      Code: 'client',
      Options: [
        'S',
        'I',
        'E',
        'D'
      ]
    },
    {
      Code: 'um',
      Options: [
        'S',
        'I',
        'E',
        'D'
      ]
    },
    {
      Code: 'rm',
      Options: [
        'S',
        'I',
        'E',
        'D'
      ]
    }
  ],
};

export default dummyResponseDataForPetroHubUser;

export const stateItemsBVCylinderByState = [
  {
    Status: 'On Hand',
    Count: 454
  },
  {
    Status: 'At Risk',
    Count: 50
  },
  {
    Status: 'Late',
    Count: 100
  },
  {
    Status: 'Late+',
    Count: 200
  }
];

export const stateSubmissionsBySampleType = [
  {
    Status: 'Case Analysis',
    Count: 454
  },
  {
    Status: 'Certificate of Analysis',
    Count: 100
  },
  {
    Status: 'DNA Analysis',
    Count: 50
  },
  {
    Status: 'Contaminant Identification',
    Count: 30
  },
  {
    Status: 'Hazard Identification',
    Count: 20
  },
  {
    Status: 'Microanalysis',
    Count: 40
  },
  {
    Status: 'Trace Analysis',
    Count: 25
  },
  {
    Status: 'Other',
    Count: 10
  },
  {
    Status: 'Case Analysis (Not. Oxygen)',
    Count: 15
  }
];

export const stateSamplesContainerTypesReceived = [
  {
    Status: 'Cylinder',
    Count: 50
  },
  {
    Status: 'Bag',
    Count: 30
  },
  {
    Status: 'Helmet',
    Count: 20
  },
  {
    Status: 'Psc Sampler',
    Count: 15
  },
  {
    Status: 'Plastic Bag',
    Count: 25
  },
  {
    Status: 'Bell Can',
    Count: 10
  },
  {
    Status: 'Cylinder/Plastic Bottle',
    Count: 5
  }
];

export const stateSampleStatus = [
  {
    Status: 'Completed',
    Count: 4747
  },
  {
    Status: 'In progress',
    Count: 373
  },
  {
    Status: 'Entered',
    Count: 18
  }
];

// export const dummySamplesData = [
//   {
//     action: 'sample_received',
//     ClientSampleID: 1213,
//     BVSampleNumber: 'BV-2024-001213',
//     JobNumber: 'JOB-2024-5421',
//     AnalysisType: 'chemical_analysis',
//     SampleDate: '2024-01-15',
//     DueDate: '2024-01-22',
//     ReportDate: '2024-01-20',
//     ReportAddress: '123 Industrial Ave, New York, NY 10001',
//     Location: 'Lab A',
//     SampleStatus: 'pending',
//     testType: 'chemical_analysis',
//     sampleType: 'material',
//     reportStatus: 'not_started',
//     compliance: 'ISO 9001',
//     classification: 'standard'
//   },
//   {
//     action: 'testing_started',
//     ClientSampleID: 1214,
//     BVSampleNumber: 'BV-2024-001214',
//     JobNumber: 'JOB-2024-5422',
//     AnalysisType: 'mechanical_testing',
//     SampleDate: '2024-01-16',
//     DueDate: '2024-01-23',
//     ReportDate: '2024-01-21',
//     ReportAddress: '456 Tech Park, Los Angeles, CA 90001',
//     Location: 'Lab B',
//     SampleStatus: 'in_progress',
//     testType: 'mechanical_testing',
//     sampleType: 'component',
//     reportStatus: 'in_progress',
//     compliance: 'ISO 14001',
//     classification: 'urgent'
//   },
//   {
//     action: 'report_issued',
//     ClientSampleID: 1215,
//     BVSampleNumber: 'BV-2024-001215',
//     JobNumber: 'JOB-2024-5423',
//     AnalysisType: 'dimensional_check',
//     SampleDate: '2024-01-17',
//     DueDate: '2024-01-24',
//     ReportDate: '2024-01-22',
//     ReportAddress: '789 Quality Blvd, Chicago, IL 60601',
//     Location: 'Lab C',
//     SampleStatus: 'completed',
//     testType: 'dimensional_check',
//     sampleType: 'product',
//     reportStatus: 'completed',
//     compliance: 'ISO 45001',
//     classification: 'standard'
//   },
//   {
//     action: 'sample_rejected',
//     ClientSampleID: 1216,
//     BVSampleNumber: 'BV-2024-001216',
//     JobNumber: 'JOB-2024-5424',
//     AnalysisType: 'quality_audit',
//     SampleDate: '2024-01-18',
//     DueDate: '2024-01-25',
//     ReportDate: '2024-01-23',
//     ReportAddress: '321 Compliance St, Houston, TX 77001',
//     Location: 'Lab A',
//     SampleStatus: 'rejected',
//     testType: 'quality_audit',
//     sampleType: 'batch',
//     reportStatus: 'failed',
//     compliance: 'Non-compliant',
//     classification: 'critical'
//   },
//   {
//     action: 'sample_received',
//     ClientSampleID: 1217,
//     BVSampleNumber: 'BV-2024-001217',
//     JobNumber: 'JOB-2024-5425',
//     AnalysisType: 'material_testing',
//     SampleDate: '2024-01-19',
//     DueDate: '2024-01-26',
//     ReportDate: '2024-01-24',
//     ReportAddress: '654 Testing Way, Phoenix, AZ 85001',
//     Location: 'Lab B',
//     SampleStatus: 'pending',
//     testType: 'material_testing',
//     sampleType: 'raw_material',
//     reportStatus: 'not_started',
//     compliance: 'ISO 9001',
//     classification: 'standard'
//   }
// ];

export const dummySampleResult = {
  status: 'success',
  timestamp: '2026-04-28T00:00:00Z',
  data: {
    samples: [
      {
        sampleId: 'DRP250',
        id: 1,
        SampleIDText: 'F36B93AF4EA2D9CC6CE74FF7EBE2048D',
        AnalysisType: 'Gas Analysis',
        MaxxAlert: 'Caution',
        ClientReview: 'Confirm',
        SampleNumber: 'DRP246',
        ClientID: '04113408_SC_1000',
        SampleDate: '2026-04-17',
        DueDate: '2026-04-28',
        ReportedDate: '2026-04-28',
        SamplePoint: 'DEHY SALES GAS TO KEYERA',
        Attention: 'STACY INGHAM',
        LsdNts: '04-11-034-08-W5M',
        Uwi: '100/04-11-034-08W5/00',
        Project: 'TOURMALINE',
        Field: 'RICINUS',
        MaxxId: 'KERIA91G',
        JobNumber: 'G610209',
        SampleStatus: 'Completed'
      },
      {
        id: 2,
        sampleId: 'DRP251',
        SampleIDText: 'F36B93AF4EA2D9CC6CE74FF7EBE2048D',
        AnalysisType: 'Liquid Hydrocarbon',
        MaxxAlert: 'Pass',
        ClientReview: 'Not Reviewed',
        SampleNumber: 'DRP248',
        ClientID: '04113408_SC_1002',
        SampleDate: '2026-04-17',
        DueDate: '2026-04-28',
        ReportedDate: '2026-04-28',
        SamplePoint: 'CONDY SALES TO KEYERA',
        Attention: 'STACY INGHAM',
        LsdNts: '04-11-034-08-W5M',
        Uwi: '100/04-11-034-08W5/00',
        Project: 'TOURMALINE',
        Field: 'RICINUS',
        MaxxId: 'KERIA91C',
        JobNumber: 'G610209',
        SampleStatus: 'Completed'
      },
      {
        id: 3,
        sampleId: 'DRP252',
        SampleIDText: 'F36B93AF4EA2D9CC6CE74FF7EBE2048D',
        AnalysisType: 'Gas Analysis',
        MaxxAlert: 'Warning',
        ClientReview: 'Confirm',
        SampleNumber: 'DRP249',
        ClientID: '10063608_SC_1000',
        SampleDate: '2026-04-17',
        DueDate: '2026-04-28',
        ReportedDate: '2026-04-28',
        SamplePoint: 'SALES GAS TO KEYERA',
        Attention: 'STACY INGHAM',
        LsdNts: '10-06-036-08-W5M',
        Uwi: '100/10-06-036-08W5/00',
        Project: 'TOURMALINE',
        Field: 'RICINUS',
        MaxxId: 'KERIA88G',
        JobNumber: 'G610209',
        SampleStatus: 'Completed'
      },
      {
        id: 4,
        sampleId: 'DRP253',
        SampleIDText: 'F36B93AF4EA2D9CC6CE74FF7EBE2048D',
        AnalysisType: 'Liquid Hydrocarbon',
        MaxxAlert: 'Caution',
        ClientReview: 'Reject',
        SampleNumber: 'DRP253',
        ClientID: '10063608_SC_1002',
        SampleDate: '2026-04-28',
        DueDate: '2026-04-28',
        ReportedDate: '2026-04-28',
        SamplePoint: 'CONDY SALES TO KEYERA',
        Attention: 'STACY INGHAM',
        LsdNts: '10-06-036-08-W5M',
        Uwi: '100/10-06-036-08W5/00',
        Project: 'TOURMALINE',
        Field: 'RICINUS',
        MaxxId: 'KERIA88C',
        JobNumber: 'G610209',
        SampleStatus: 'Completed'
      },
      {
        id: 5,
        sampleId: 'DRP698',
        SampleIDText: 'F36B93AF4EA2D9CC6CE74FF7EBE2048D',
        AnalysisType: 'Condensate Equalization',
        MaxxAlert: 'Caution',
        ClientReview: 'Confirm',
        SampleNumber: 'DRP250',
        ClientID: '7984',
        SampleDate: '2026-04-15',
        DueDate: '2026-04-28',
        ReportedDate: '2026-04-28',
        SamplePoint: 'FOX CREEK TRUCK RACK C5+ IN SUPPLIER - COMPOSITE',
        Attention: 'Julie Kos',
        LsdNts: '02-13-062-19-W5M',
        Uwi: null,
        Project: 'KAPS FOX CREEK TRUCK RACK C5+ IN - COMPOSITE',
        Field: 'FOX CREEK',
        MaxxId: 'KAPSA56M',
        JobNumber: 'G610325',
        SampleStatus: 'Completed'
      },
      {
        id: 6,
        sampleId: 'DRP699',
        SampleIDText: 'F36B93AF4EA2D9CC6CE74FF7EBE2048D',
        AnalysisType: 'Trace Sulphur',
        MaxxAlert: 'Pass',
        ClientReview: 'Confirm',
        SampleNumber: 'DRP251',
        ClientID: '7984',
        SampleDate: '2026-04-15',
        DueDate: '2026-04-28',
        ReportedDate: '2026-04-28',
        SamplePoint: 'FOX CREEK TRUCK RACK C5+ IN SUPPLIER - COMPOSITE',
        Attention: 'Julie Kos',
        LsdNts: '02-13-062-19-W5M',
        Uwi: null,
        Project: 'KAPS FOX CREEK TRUCK RACK C5+ IN - COMPOSITE',
        Field: 'FOX CREEK',
        MaxxId: 'KAPSA56TR',
        JobNumber: 'G610325',
        SampleStatus: 'Completed'
      },
      {
        id: 7,
        sampleId: 'DRP700',
        SampleIDText: 'F36B93AF4EA2D9CC6CE74FF7EBE2048D',
        AnalysisType: 'Condensate Equalization',
        MaxxAlert: 'Warning',
        ClientReview: 'Confirm',
        SampleNumber: 'DRP250',
        ClientID: '7985',
        SampleDate: '2026-04-15',
        DueDate: '2026-04-28',
        ReportedDate: '2026-04-28',
        SamplePoint: 'FOX CREEK TRUCK RACK C5+ IN SUPPLIER - COMPOSITE',
        Attention: 'Julie Kos',
        LsdNts: '02-13-062-19-W5M',
        Uwi: null,
        Project: 'KAPS FOX CREEK TRUCK RACK C5+ IN - COMPOSITE',
        Field: 'FOX CREEK',
        MaxxId: 'KAPSA56M',
        JobNumber: 'G610325',
        SampleStatus: 'Completed'
      },
      {
        id: 8,
        sampleId: 'DRP701',
        SampleIDText: 'F36B93AF4EA2D9CC6CE74FF7EBE2048D',
        AnalysisType: 'Trace Sulphur',
        MaxxAlert: 'Pass',
        ClientReview: 'Reject',
        SampleNumber: 'DRP251',
        ClientID: '7985',
        SampleDate: '2026-04-15',
        DueDate: '2026-04-28',
        ReportedDate: '2026-04-28',
        SamplePoint: 'FOX CREEK TRUCK RACK C5+ IN SUPPLIER - COMPOSITE',
        Attention: 'Julie Kos',
        LsdNts: '02-13-062-19-W5M',
        Uwi: null,
        Project: 'KAPS FOX CREEK TRUCK RACK C5+ IN - COMPOSITE',
        Field: 'FOX CREEK',
        MaxxId: 'KAPSA56TR',
        JobNumber: 'G610325',
        SampleStatus: 'Completed'
      }
    ],
    summary: {
      totalSamples: 11,
      completedSamples: 11,
      AnalysisTypeBreakdown: {
        GasAnalysis: 3,
        LiquidHydrocarbon: 3,
        LpgExtended: 1,
        CondensateEqualization: 2,
        TraceSulphur: 2
      },
      ClientReviewBreakdown: {
        Confirm: 8,
        Reject: 1,
        Pending: 2
      }
    }
  },
  Meta: {
    PageSize: 11,
    PageNumber: 1,
    TotalRecords: 11
  }
};

export const dummySampleDetailsData = {
  Location: 'LSD 14-22-45-12W4',
  sampleId: 'DRP251',
  Job: 'J-45892',
  MaxxALERT: 'PASS',
  AnalysisType: 'Trace Sulphur',
  MaxxAlert: 'Acceptable',
  ClientReview: 'Confirm',
  Invoice: 0,
  Matrix: 'LIQUID',
  Sample: 'DRP251',
  ClientID: '7985',
  ClientStatus: 'Accepted',
  SampleDate: '2026-04-15',
  DueDate: '2026-04-28',
  ReportedDate: '2026-04-28',
  SamplePoint: 'Phase 1 Bunker Fuel',
  Attention: 'Julie Kos',
  LsdNts: '02-13-062-19-W5M',
  Uwi: null,
  Project: 'KAPS FOX CREEK TRUCK RACK C5+ IN - COMPOSITE',
  Field: 'FOX CREEK',
  MaxxID: 'KAPSA56TR',
  JobNumber: 'G610325',
  SampleStatus: 'Completed',
  SampleIDText: 'F36B93AF4EA2D9CC6CE74FF7EBE2048D',
  WorkTypeID: 0,
  JobIDText: 'AE4AD98061CCDCDFFED68765338FF121',
  LocationID: 695214,
  StatusID: 402,
  SampleCategoryText: 'ClientSample',
  ClientSampleNo: '1997297-3',
  SampleSequence: 1,
  SupplierID: null,
  SpecType: '',
  NumberOfBags: null,
  SampleStation: 'Before Separator',
  BunkeringPort: null,
  MassReceived: null,
  Description: '',
  TrainNumber: '',
  VesselName: 'Astraka',
  ProductName: null,
  WorkTypeName: null,
  ConsignmentNumber: '9883133551',
  IMOnumber: '9478822',
  NumberOfWagons: null,
  ReceivedDate: '2026-05-25T15:06:54',
  BunkerDate: '2026-05-15T13:51:20',
  ReceivedBy: 'EUA\\amaravella',
  ApprovedOn: null,
  ApprovedBy: '',
  SampleMethod: '',
  SampleTonnage: null,
  AnalysisStartDate: null,
  SamplingDate: '2026-05-15T13:51:20',
  ClientSampleRef: '',
  ProductID: 326170,
  GradeName: 'Fuel System',
  ProductSulphurContent: '',
  SentFrom: '326559',
  SentBy: '326064',
  SentOn: '2026-05-20T15:07:06',
  BatchLotRef: '1997297',
  DivisionID: 9,
  Flags: 0,
  LastUpdatedOn: '2026-05-25T12:07:11',
  LastUpdatedBy: 'EUA\\amaravella',
  CreatedOn: '2026-05-25T10:51:44',
  CreatedBy: 'EUA\\dagriou',
  SourceSystemID: 11,
};
export const sampleResultsData = [
  {
    section: 'Analysis 1',
    items: [
      {
        parameter: 'Carbon Monoxide (CO)',
        unit: 'mole/mole',
        result: '0.0067',
        previousResult: '0.0079',
        historicalAvg: '0.0046',
        variance: '0.0021',
        tFactor: '1.0',
      },
      {
        parameter: 'Hydrogen (H₂)',
        unit: 'mole/mole',
        result: '0.1419',
        previousResult: '0.1219',
        historicalAvg: '0.1104',
        variance: '0.0315',
        tFactor: '0.8',
      },
      {
        parameter: 'Helium (He)',
        unit: 'mole/mole',
        result: 'TCS',
        previousResult: '0.0000',
        historicalAvg: '',
        variance: '',
        tFactor: '',
      },
      {
        parameter: 'Oxygen (O₂)',
        unit: 'mole/mole',
        result: '',
        previousResult: '0.0040',
        historicalAvg: '0.0563',
        variance: '0.0525',
        tFactor: '1.0',
      },
    ],
  },
  {
    section: 'Other/Miscellaneous',
    items: [
      {
        parameter: 'Nitrogen (N₂)',
        unit: 'mole/mole',
        result: '0.0150',
        previousResult: '0.0144',
        historicalAvg: '0.2230',
        variance: '-0.2080',
        tFactor: '1.1',
      },
      {
        parameter: 'Carbon Dioxide (CO₂)',
        unit: 'mole/mole',
        result: '0.0096',
        previousResult: '0.0104',
        historicalAvg: '0.0056',
        variance: '0.0040',
        tFactor: '1.4',
      },
      {
        parameter: 'Hydrogen Sulphide (H₂S)',
        unit: 'mole/mole',
        result: '0.1285',
        previousResult: '0.1450',
        historicalAvg: '0.0623',
        variance: '0.0462',
        tFactor: '1.3',
      },
      {
        parameter: 'Methane (C₁)',
        unit: 'mole/mole',
        result: '0.2019',
        previousResult: '0.2175',
        historicalAvg: '0.1616',
        variance: '0.0403',
        tFactor: '0.8',
      },
    ],
  },
];
export const jobReportData = [
  {
    JobReportID: 122612,
    JobIDText: '4004D5D38479E202CA3B820EFE9ECDF0',
    ReportType: 'Other',
    Title: 'Danaos_BunkerAnalysis_Fuel',
    Description: 'Danaos_BunkerAnalysis_Fuel',
    Filename: 'Danaos_BunkerAnalysis_Fuel_1975356-1.XLSX',
    FilePath: 's3://ctn-abv-ut-data/Unknown/JobReports/202604/10/Danaos_BunkerAnalysis_Fuel_1975356-1.XLSX_10042026081020.XLSX',
    GeneratedOn: '2026-04-10T08:09:18',
    DateAdded: '2026-04-10T08:09:18',
    GeneratedBy: 'ASI\\shatripathi',
    ClientID: 588580,
    SourceSystemID: 10,
    SourceSystemRecordID: '768096_928339',
    JobName: '1975356',
    ClientSampleNo: '1975356-1',
    SampleIDText: 'A4F4867F48911EEAEBC27CF88C6410ED',
    ContractID: '182170',
    UserType: 'Client',
    LastDownloadedOn: null,
    LastDownloadedBy: null,
    LastDownloadedUserIdBy: null
  },
  {
    JobReportID: 122500,
    JobIDText: '4004D5D38479E202CA3B820EFE9ECDF0',
    ReportType: 'COA',
    Title: 'Operational Report',
    Description: 'Operational Report',
    Filename: 'OpsReport_1975356-1_v1.PDF',
    FilePath: '\\\\amznfsxf9botprs.eua.bvcorp.corp\\share\\CTD_UAT\\ABV\\Reports\\202602\\23\\cca2eb5da50f4dceaaf7ff6962247c26',
    GeneratedOn: '2026-02-23T23:39:27',
    DateAdded: '2026-02-23T23:39:27',
    GeneratedBy: 'PAC\\hamkhan',
    ClientID: 588580,
    SourceSystemID: 10,
    SourceSystemRecordID: '768095_928339',
    JobName: '1975356',
    ClientSampleNo: '1975356-1',
    SampleIDText: 'A4F4867F48911EEAEBC27CF88C6410ED',
    ContractID: '182170',
    UserType: 'Client',
    LastDownloadedOn: '2026-05-15T05:43:06',
    LastDownloadedBy: 'Shyam vir',
    LastDownloadedUserIdBy: '1274'
  },
  {
    JobReportID: 122499,
    JobIDText: '4004D5D38479E202CA3B820EFE9ECDF0',
    ReportType: 'COA',
    Title: 'Spec Report',
    Description: 'Spec Report',
    Filename: 'SpecReport_1975356-1_v1.PDF',
    FilePath: '\\\\amznfsxf9botprs.eua.bvcorp.corp\\share\\CTD_UAT\\ABV\\Reports\\202602\\23\\860a19d0bae4402daaa8089f075cd2c1',
    GeneratedOn: '2026-02-23T23:39:12',
    DateAdded: '2026-02-23T23:39:12',
    GeneratedBy: 'PAC\\hamkhan',
    ClientID: 588580,
    SourceSystemID: 10,
    SourceSystemRecordID: '768094_928339',
    JobName: '1975356',
    ClientSampleNo: '1975356-1',
    SampleIDText: 'A4F4867F48911EEAEBC27CF88C6410ED',
    ContractID: '182170',
    UserType: 'Client',
    LastDownloadedOn: '2026-05-15T05:43:06',
    LastDownloadedBy: 'Shyam vir',
    LastDownloadedUserIdBy: '1274'
  },
  {
    JobReportID: 122439,
    JobIDText: '4004D5D38479E202CA3B820EFE9ECDF0',
    ReportType: 'Submission',
    Title: 'Submission',
    Description: 'Submission',
    Filename: 'SubmissionForm.json',
    FilePath: '\\\\amznfsxf9botprs.eua.bvcorp.corp\\share\\CTD_UAT\\ABV\\Reports\\202602\\06\\e24130386b9444978fc51d4950656dcb',
    GeneratedOn: '2026-02-06T15:46:51',
    DateAdded: '2026-02-06T15:46:51',
    GeneratedBy: 'EUA\\PTzemopoulos',
    ClientID: 588580,
    SourceSystemID: 10,
    SourceSystemRecordID: '29_928339_Submission',
    JobName: '1975356',
    ClientSampleNo: '1975356-1',
    SampleIDText: 'A4F4867F48911EEAEBC27CF88C6410ED',
    ContractID: '182170',
    UserType: 'Client',
    LastDownloadedOn: '2026-02-23T07:44:43',
    LastDownloadedBy: 'Dheeraj GABA',
    LastDownloadedUserIdBy: '1131'
  }
];
